import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
export function playerFactory() {
	return import('lottie-web');
}

@NgModule({
	declarations: [HomeComponent],
	imports: [CommonModule, ComponentsModule, HomeRoutingModule, LottieComponent, PipesModule],
	providers: [provideLottieOptions({ player: playerFactory })],
	exports: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
